import keyMirror from 'keymirror'

export default keyMirror({
  GET_LIST_KIT_UPDATE_PERS_REQUEST: null,
  GET_LIST_KIT_UPDATE_PERS_SUCCESS: null,
  GET_LIST_KIT_UPDATE_PERS_FAILED: null,

  GET_DETAIL_KIT_UPDATE_PERS_REQUEST: null,
  GET_DETAIL_KIT_UPDATE_PERS_SUCCESS: null,
  GET_DETAIL_KIT_UPDATE_PERS_FAILED: null,

  DELETE_KIT_UPDATE_PERS_REQUEST: null,
  DELETE_KIT_UPDATE_PERS_SUCCESS: null,
  DELETE_KIT_UPDATE_PERS_FAILED: null,

  ADD_KIT_UPDATE_PERS_REQUEST: null,
  ADD_KIT_UPDATE_PERS_SUCCESS: null,
  ADD_KIT_UPDATE_PERS_FAILED: null,

  UPDATE_KIT_UPDATE_PERS_REQUEST: null,
  UPDATE_KIT_UPDATE_PERS_SUCCESS: null,
  UPDATE_KIT_UPDATE_PERS_FAILED: null,

  TRANSITION_KIT_UPDATE_PERS_REQUEST: null,
  TRANSITION_KIT_UPDATE_PERS_SUCCESS: null,
  TRANSITION_KIT_UPDATE_PERS_FAILED: null,

  ATTACH_KIT_UPDATE_PERS_TARGETS_REQUEST: null,
  ATTACH_KIT_UPDATE_PERS_TARGETS_SUCCESS: null,
  ATTACH_KIT_UPDATE_PERS_TARGETS_FAILED: null,

  DETACH_KIT_UPDATE_PERS_TARGET_REQUEST: null,
  DETACH_KIT_UPDATE_PERS_TARGET_SUCCESS: null,
  DETACH_KIT_UPDATE_PERS_TARGET_FAILED: null,

  BULK_DETACH_KIT_UPDATE_PERS_TARGETS_REQUEST: null,
  BULK_DETACH_KIT_UPDATE_PERS_TARGETS_SUCCESS: null,
  BULK_DETACH_KIT_UPDATE_PERS_TARGETS_FAILED: null,

  SEARCH_KIT_UPDATE_PERS_PICKER_PERS_REQUEST: null,
  SEARCH_KIT_UPDATE_PERS_PICKER_PERS_SUCCESS: null,
  SEARCH_KIT_UPDATE_PERS_PICKER_PERS_FAILED: null
})
